import { useState } from "react";
import { BasketItem, setBasketItemExercise } from "../../../models/BasketItem";
import { Assort } from "../../../models/Assort";
import useFacility from "../../../../utils/hooks/useFacility";
import getId from "../../../../utils/getId";
import { TicketAccess } from "../../../models/TicketAccess";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { format } from "date-fns";
import { GET_EXERCISE_BY_PASSID } from "../../../api/apiRoutes";

export default function usePreBasket() {
  const [preBasket, setPreBasket] = useState<BasketItem[]>([]);
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const isAssortInBasket = (assort: Assort) => {
    return preBasket.some((item: BasketItem) => item.assortIds === getId(assort));
  };

  const checkQnt = (assort: Assort) => {
    const item = preBasket.find((item: BasketItem) => item.assortIds === getId(assort));
    return item ? item.qnt : 0;
  };

  const setBasketItem = (assort: Assort): BasketItem => {
    return {
      assortIds: getId(assort),
      qnt: 1,
      facilityIds,
      price: assort.listPrice,
    } as BasketItem;
  };

  // facilityIds: string, formattedDateFrom: string, formattedDateTo: string, passIds:string
  const getExerciseByPassFlexi = async (assortId: number) => {
    const dayFrom = format(new Date(), "yyyy-MM-dd");
    const ids = `0,${assortId}`;
    const { result, isError } = await get(GET_EXERCISE_BY_PASSID(facilityIds, dayFrom, dayFrom, ids));
    if (!isError) {
    }
  };

  const getBasketItemExerciseByAssortMinSale = (assort: Assort, ticketAccess: TicketAccess) => {
    if (checkQnt(assort) >= assort.minSale) {
      return setBasketItemExercise(facilityIds, getId(assort), assort.price, [ticketAccess], null, 1);
    } else {
      return setBasketItemExercise(facilityIds, getId(assort), assort.price, [ticketAccess], null, assort.minSale);
    }
  };

  const handleAddToBasketWithoutTicketAccess = (assort: Assort) => {
    if (isAssortInBasket(assort)) {
      setPreBasket(preBasket.map((item) => (item.assortIds === getId(assort) ? { ...item, qnt: item.qnt + 1 } : item)));
    } else {
      setPreBasket([setBasketItem(assort), ...preBasket]);
    }
  };

  const handleAddToBasketWithTicketAccess = (assort: Assort, ticketAccess: TicketAccess) => {
   
    if (isAssortInBasket(assort)) {
      const foundItem = preBasket.find((item: BasketItem) => item.assortIds === getId(assort));
      if (
        foundItem?.ticketAccess.some((ticketAccessItem) => ticketAccessItem.exerciseIds === ticketAccess.exerciseIds)
      ) {
        setPreBasket(
          preBasket.map((item) => (item.assortIds === getId(assort) ? { ...item, qnt: item.qnt + 1 } : item))
        );
      } else {
        setPreBasket([getBasketItemExerciseByAssortMinSale(assort, ticketAccess), ...preBasket]);
      }
    } else {
      setPreBasket([getBasketItemExerciseByAssortMinSale(assort, ticketAccess), ...preBasket]);
    }
  };

  const addItemToBasket = (assort: Assort, ticketAccess?: TicketAccess) => {
    getExerciseByPassFlexi(assort.objectId);
    if (ticketAccess && ticketAccess?.exerciseIds) {
      handleAddToBasketWithTicketAccess(assort, ticketAccess);
    } else {
      handleAddToBasketWithoutTicketAccess(assort);
    }
  };

  const validateRemove = (assort: Assort): boolean => {
    if (isAssortInBasket(assort)) {
      const itemBasket = preBasket.find((item) => item.assortIds === getId(assort));
      if (itemBasket) {
        return itemBasket.qnt > 1;
      }
    }
    return false;
  };

  const handleRemoveItemWithoutTicketAccess = (assort: Assort) => {
    if (validateRemove(assort)) {
      if (checkQnt(assort) === assort.minSale) {
        setPreBasket(preBasket.filter((item) => item.assortIds !== getId(assort)));
      } else {
        setPreBasket(
          preBasket.map((item) => (item.assortIds === getId(assort) ? { ...item, qnt: item.qnt - 1 } : item))
        );
      }
    } else {
      setPreBasket(preBasket.filter((item) => item.assortIds !== getId(assort)));
    }
  };

  const handleRemoveItemWithWithTicketAccess = (assort: Assort, ticketAccess: TicketAccess) => {
    const filteredPreBasket = preBasket.filter(
      (item: BasketItem) =>
        item.assortIds === getId(assort) &&
        item.ticketAccess.some((ticketAccessItem) => ticketAccessItem.exerciseIds === ticketAccess.exerciseIds)
    );
    const otherPreBasketItems = preBasket.filter(
      (item: BasketItem) =>
        item.assortIds !== getId(assort) ||
        (item.assortIds === getId(assort) && item.ticketAccess[0].exerciseIds !== ticketAccess.exerciseIds)
    );
    if (filteredPreBasket.length > 0) {
      if (checkQnt(assort) === assort.minSale) {
        const updatedPreBasket = filteredPreBasket.slice(1);
        setPreBasket([...updatedPreBasket, ...otherPreBasketItems]);
      } else {
        setPreBasket(
          preBasket.map((item) => (item.assortIds === getId(assort) ? { ...item, qnt: item.qnt - 1 } : item))
        );
      }
    } else {
      setPreBasket(preBasket.filter((item) => item.assortIds !== getId(assort)));
    }
  };

  const removeItemFromBasket = (assort: Assort, ticketAccess?: TicketAccess) => {
    if (ticketAccess && ticketAccess.exerciseIds) {
      handleRemoveItemWithWithTicketAccess(assort, ticketAccess);
    } else {
      handleRemoveItemWithoutTicketAccess(assort);
    }
  };

  const clearBasket = () => {
    setPreBasket([]);
  };

  return {
    preBasket,
    addItemToBasket,
    removeItemFromBasket,
    clearBasket,
  };
}
